<template>
  <v-col cols="12" class="text-center">
    <v-tabs color="red" align-tabs="center" v-model="selectedPedidos">
      <v-tab :value="'Em Andamento'">Em Andamento</v-tab>
      <v-tab :value="'Finalizados'" @click="manipulateData('Finalizados')"
        >Finalizados</v-tab
      >
    </v-tabs>
    <template v-for="empresa in this.empresas" :key="empresa">
      <template v-if="pedidosData.find((val) => val.empresa == empresa)">
        <v-col class="text-left">
          <v-col>
            <span class="text-h6 text-grey">{{
              selectedEmpresa == null
                ? "Estabelecimentos"
                : "Pedidos de " +
                  empresasData.find((val) => val.empresa == empresa)
                    .dadosempresa.nome
            }}</span>
          </v-col>
          <v-col v-if="selectedEmpresa != null">
            <v-btn
              @click="
                (selectedEmpresa = null),
                  (registerLimit = 5),
                  this.$router.push('/meusDados/pedidos')
              "
              variant="plain"
              color="red-darken-4"
              >Voltar</v-btn
            >
          </v-col>
        </v-col>
        <v-col>
          <v-card
            @click="pushPedidos(empresa)"
            v-if="selectedEmpresa == null"
            class="mx-auto mt-1"
            max-width="344"
          >
            <v-avatar size="150" rounded="1">
              <v-img
                :src="
                  empresasData.find((val) => val.empresa == empresa)
                    .dadosempresa.img_url
                "
              ></v-img>
            </v-avatar>
            <v-card-title>
              {{
                empresasData.find((val) => val.empresa == empresa).dadosempresa
                  .nome
              }}
            </v-card-title>
            <span class="text-grey text-center">Clique para ver Pedidos</span>
          </v-card>
        </v-col>
      </template>
      <template v-if="selectedEmpresa != null">
        <template v-for="(pedido, index) in visiblePedidos" :key="pedido">
          <template
            v-if="pedido.empresa == selectedEmpresa && index < registerLimit"
          >
            <v-card
              class="mt-1 mx-auto"
              max-width="344"
              @click="setDialogFinanceiro(pedido)"
            >
              <v-card-title
                >{{ mdAndUp ? "Pedido #" : "#" }}{{ pedido.num }}</v-card-title
              >
              <v-card-text
                ><span class="text-grey"
                  >Clique para obter informaçoes
                  <v-icon>mdi-note-text-outline</v-icon></span
                ></v-card-text
              >
            </v-card>
          </template>
        </template>
        <v-btn
          @click="increaseLimit"
          v-if="hasMorePedidos(selectedEmpresa)"
          color="green-darken-4"
          variant="plain"
          >Carregar mais</v-btn
        >
      </template>
    </template>
  </v-col>
  <dialogPedido></dialogPedido>
  <v-btn
    v-if="floatingButton"
    @click="scrollTop"
    style="position: fixed; bottom: 10px; right: 25px"
    variant="plain"
    icon
    color="red-darken-4"
    ><v-icon color="red-darken-4">mdi-arrow-up</v-icon></v-btn
  >
</template>
<script>
import { mapGetters } from "vuex";
import { useDisplay } from "vuetify";
import updateUser from "../../libs/updateUser";
import { store } from "../../store/store";
import axios from "axios";
import stringSimilarity from "string-similarity";
import checkStatus from "../../libs/checkStatus";
import checkStatusFinalizados from "../../libs/checkStatusFinalizados";

import getDadosEmpresa from "../../libs/getDadosEmpresa";
import dialogPedido from "../../components/dialogPedido.vue";

var image = require("../../assets/logowithtext.svg");

export default {
  name: "meusPedidos",
  components: {
    dialogPedido,
  },
  data: () => ({
    intervalId: null,
    isDataManipulated: false,
    intervalIdLoaded: null,
    isDataLoaded: false,
    empresas: [],
    pedidosOld: [],
    pedidosOldFinalizados: [],
    registerLimit: 5,
    selectedEmpresa: null,
    empresasData: [],
    pedisosData: [],
    tab: "account",
    selectedPedidos: "Em Andamento",
    drawer: true,
    rail: true,
    floatingButton: false,
    edit: [false, false, false, false, false, false],
    formValido: false,
    items: [
      {
        title: "Meus Dados",
        value: 1,
        props: {
          prependIcon: "mdi-user",
        },
      },
      {
        title: "Acompanhamento",
        value: 2,
      },
    ],
    image: image,
    teste: "",
  }),
  setup() {
    // Destructure only the keys we want to use
    const { xs, mdAndUp } = useDisplay();

    return { xs, mdAndUp };
  },
  watch: {
    "$route.query.id"(n) {
      if (n == undefined) {
        this.selectedEmpresa = null;
        let dialog = {
          ativo: false,
          pedido: "",
        };
        store.commit("incrementDialogFinanceiro", dialog);
      } else {
        this.selectedEmpresa = this.$route.query.id;
      }
    },
    selectedPedidos(n) {
      if (n == "Em Andamento") {
        this.pedidosOldFinalizados = this.pedidosData;
        if (this.pedidosOld) {
          this.selectedEmpresa = null;
          this.pedidosData = this.pedidosOld;
        }
      } else {
        this.pedidosOld = this.pedidosData;
        if (this.pedidosOldFinalizados) {
          this.selectedEmpresa = null;
          this.pedidosData = this.pedidosOldFinalizados;
        }
      }
    },
    "logado.data": {
      handler() {
        this.registroEdit = JSON.parse(JSON.stringify(this.logado.data));
      },
      deep: true,
    },
    async "registroEdit.cep"(n) {
      if (n.length == 8 && this.edit[3] == true) {
        {
          const response = await axios({
            method: "get",
            url: `https://viacep.com.br/ws/${n}/json/`,
          });
          this.edit[4] = true;
          this.edit[5] = true;
          this.registroEdit.endereco = response.data.logradouro;
          this.registroEdit.bairro = this.matchBairro(response);
        }
      }
    },
  },

  computed: {
    visiblePedidos() {
      return this.pedidosData
        .filter((pedido) => pedido.empresa === this.selectedEmpresa)
        .sort((a, b) => b.num - a.num);
    },
    ...mapGetters([
      "selecionadoCategorias",
      "database",
      "dadosEmpresa",
      "carrinho",
      "pedidos",
      "produtos",
      "categorias",
      "horario",
      "busca",
      "disableDelivery",
      "disableEncomenda",
      "combos",
      "shownAlert",
      "bairros",
      "logado",
    ]),
  },
  methods: {
    setDialogFinanceiro(i) {
      let dialog = {
        ativo: true,
        pedido: i,
      };
      store.commit("incrementDialogFinanceiro", dialog);
    },
    pushPedidos(empresa) {
      this.$router.push({ path: "/meusDados/pedidos", query: { id: empresa } });
      this.selectedEmpresa = empresa;
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onScroll() {
      this.floatingButton = window.scrollY > 0;
    },
    countPedidosByEmpresa(empresa) {
      return this.pedidosData.filter((pedido) => pedido.empresa === empresa)
        .length;
    },
    hasMorePedidos(selectedEmpresa) {
      const count = this.countPedidosByEmpresa(selectedEmpresa);
      return count > this.registerLimit;
    },
    increaseLimit() {
      this.registerLimit += 5; // Increase the limit by 10 (or adjust as needed)
    },
    manipulateData(n) {
      let response = [];
      if (n == "Andamento") {
        this.selectedEmpresa = null;
        response = checkStatus();
      } else {
        if (this.isDataLoaded) {
          this.timeoutId = setTimeout(
            () => {
              this.isDataLoaded = false;
            },
            3 * 60 * 1000,
          ); // 3 minutes in milliseconds
        } else {
          this.selectedEmpresa = null;
          this.isDataLoaded = true;
          response = checkStatusFinalizados();
        }
      }
      if (response != "") {
        response.then(async (data) => {
          const empresas = new Set(); // Use a Set to store unique empresa values
          const pedidosData = [];

          // Iterate over the data and extract the empresa values
          data.data.result.data.forEach((item) => {
            empresas.add(item.empresa);
            pedidosData.push(item);
          });

          const empresasList = Array.from(empresas); // Convert the Set to an array

          for (let empresa of empresasList) {
            const dadosEmpresa = await getDadosEmpresa(empresa, true);
            var dados = Object.values(dadosEmpresa)[0];
            dados.empresa = Object.keys(dadosEmpresa)[0];
            dados = JSON.stringify(dados);
            this.empresasData.push(JSON.parse(dados));
          }
          this.empresas = empresasList;
          this.pedidosData = pedidosData;
        });
      }
    },

    matchBairro(response) {
      const bairroNames = this.bairros.map((bairro) => bairro.nome);
      const matches = stringSimilarity.findBestMatch(
        response.data.bairro,
        bairroNames,
      );

      const bestMatch = matches.bestMatch.target;
      const matchedBairro = this.bairros.find(
        (bairro) => bairro.nome === bestMatch,
      );

      return matchedBairro;
    },

    atualizaDados() {
      this.registroEdit.whatsapp =
        "55" + this.registroEdit.telefone.replace(/[() -]/g, "");

      updateUser(this.registroEdit).then((n) => {
        if (n.status == 200) {
          let updatedFields = n.data.data;
          let logado = this.logado;
          logado.data = {
            bairro: updatedFields.bairro,
            cidade: updatedFields.cidade,
            endereco: updatedFields.endereco,
            nome: updatedFields.nome,
            sobrenome: updatedFields.sobrenome,
            telefone: updatedFields.telefone,
            cep: updatedFields.cep,
            cpf: logado.data.cpf,
            whatsapp: updatedFields.whatsapp,
          };

          store.commit("incrementLogado", logado);
          this.edit = [false, false, false, false, false, false];
        }
      });
    },
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    clearInterval(this.intervalId);
    clearTimeout(this.intervalIdLoaded);
  },
  mounted() {
    if (this.$route.query.id) {
      this.selectedEmpresa = this.$route.query.id;
    }
    window.addEventListener("scroll", this.onScroll);
    if (this.selectedPedidos === "Em Andamento" && !this.isDataManipulated) {
      this.manipulateData("Andamento");
    }
    this.intervalId = setInterval(
      () => {
        console.log(1);
        if (
          this.selectedPedidos === "Em Andamento" &&
          !this.isDataManipulated
        ) {
          this.manipulateData("Andamento");
          this.isDataManipulated = true;
        }
      },
      3 * 60 * 1000,
    );
    setTimeout(() => {
      this.registroEdit = JSON.parse(JSON.stringify(this.logado.data));
      if (
        this.logado.message != "sucess" &&
        this.logado.message != "Usuário Logado com sucesso."
      ) {
        this.$router.push("/");
      }
    }, 100);
  },

  activated() {},
};
</script>
<style lang="scss" scoped></style>
